import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import styled from "styled-components";

const Main = () => {
  const [inputValue, setInputValue] = useState("");
  const scrollRef = useRef();

  const [state, setState] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
  });

  const { vertical, horizontal, open } = state;

  const [nameSnack, setNameSnack] = useState(false);

  const closeNameSnack = () => {
    setNameSnack(current => !current);
  };

  const handleClick = () => {
    setState({ ...state, open: true });
    scrollRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const navigate = useNavigate();

  const enterKey = e => {
    if (e.key === "Enter") {
      handleClick();
    }
  };

  const onPutInput = e => {
    let inputFilter = e.target.value;
    let reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim;
    let inputResult = inputFilter.replace(reg, "");
    setInputValue(inputResult);
  };

  const inputValid = inputValue.length > 1 && inputValue.length < 9;

  const onStartQuiz = () => {
    if (inputValid) {
      navigate("/eventOldQuiz/quiz", { state: { name: inputValue } });
    } else {
      setNameSnack(true);
    }
  };

  return (
    <MainBox>
      <MainTopBox>
        <MainLogoBox>
          <MainLogo src="/images/sinor-logo.png" />
        </MainLogoBox>
        <MainSubTitle>2022년 학력고사 문제지</MainSubTitle>
        <MainTitle>추억 영역</MainTitle>
        <MainInputBox>
          <MainInputName>이름</MainInputName>
          <MainInput
            onChange={onPutInput}
            value={inputValue}
            onKeyDown={enterKey}
            placeholder="이름을 입력해주세요"
          />
          {open && (
            <SnackbarStyle>
              <Snackbar
                style={{
                  color: "white",
                  margin: "0 auto",
                }}
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                message="하단의 5문제 풀기 버튼을 눌러주세요!"
                key={vertical + horizontal}
              />
            </SnackbarStyle>
          )}
          <SubmitBtn onClick={handleClick} ref={scrollRef}>
            입력
          </SubmitBtn>
        </MainInputBox>
        <MainInputText />
        <MainTextBox>
          <MainTextCtn>
            {MAIN_DESC_INFO.map(info => (
              <MainText key={info.id}>{info.text}</MainText>
            ))}
          </MainTextCtn>
        </MainTextBox>
        <MainAlert>※ 시험이 시작되기 전까지 표지를 넘기지 마시오.</MainAlert>
        <MainStartBtnBox>
          <MainStartBtn onClick={onStartQuiz}>5 문제 풀기</MainStartBtn>
          {nameSnack && (
            <Snackbar
              open={nameSnack}
              onClose={closeNameSnack}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <Alert
                severity="error"
                onClose={closeNameSnack}
                style={{
                  backgroundColor: "#000000",
                  color: "#ffffff",
                }}
              >
                이름을 입력하세요!
              </Alert>
            </Snackbar>
          )}
        </MainStartBtnBox>
      </MainTopBox>
      <div ref={scrollRef} />
    </MainBox>
  );
};

export default Main;

const MAIN_DESC_INFO = [
  {
    id: 1,
    text: (
      <p>
        ○ 학력고사는 <strong>누구나 풀 수 있는 문제들로 구성</strong>되어
        있습니다.
      </p>
    ),
  },
  {
    id: 2,
    text: (
      <p>
        ○ 만약 성적이 마음에 안드신다면
        <strong> 재시험이 가능</strong>
        합니다.
      </p>
    ),
  },
  {
    id: 3,
    text: (
      <p>
        ○ 모든 문제를 맞혀야 <strong>500 포인트</strong>를 드립니다.
      </p>
    ),
  },
  {
    id: 4,
    text: (
      <p>
        ○ 포인트는 <strong>회원 당 1회만 </strong>지급해 드립니다. (중복 수령
        불가)
      </p>
    ),
  },
  {
    id: 5,
    text: (
      <p>○ 이름과 핸드폰 번호를 입력해 주셔야만 포인트를 지급 해드립니다.</p>
    ),
  },
];

const MainBox = styled.div`
  width: 1000px;
  margin: 0 auto;
  background-color: #ececec;

  @media screen and (max-width: 1000px) {
    width: 100vw;
  }
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
  @media screen and (max-width: 700px) {
    font-size: 12px;
  }
  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
  @media screen and (max-width: 300px) {
    font-size: 8px;
  }
`;

const MainTopBox = styled.div`
  padding: 5em;
`;

const MainLogoBox = styled.div`
  width: 8em;
  margin: 0 auto;
  margin-bottom: 30px;
`;

const MainLogo = styled.img`
  width: 100%;
  height: 100%;
`;

const MainSubTitle = styled.p`
  font-family: ${props => props.theme.style.yangjin};
  padding-top: 0.5em;
  margin: 0 auto;
  text-align: center;
  font-size: 2em;
`;

const MainTitle = styled.p`
  font-family: ${props => props.theme.style.yangjin};
  margin-top: 0.5em;
  text-align: center;
  font-size: 5em;
`;

const MainInputBox = styled.div`
  ${props => props.theme.variables.flex("", "space-between", "center")}
  width: 100%;
  height: 3em;
  margin: 2.3em auto 0;
  border: 2px solid ${props => props.theme.style.black};
  font-size: 1.3em;
`;

const MainInputName = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  border-right: 2px solid ${props => props.theme.style.black};
  font-family: ${props => props.theme.style.yangjin};
  width: 20%;
  height: 100%;
  text-align: center;
  white-space: nowrap;
`;

const MainInput = styled.input`
  font-size: 1.3em;
  width: 100%;
  height: 100%;
  padding: 0;
  padding-left: 0.5em;
  outline: none;
  border: none;
  background-color: #f1f1f1;
`;

const SnackbarStyle = styled.div`
  .css-1eqdgzv-MuiPaper-root-MuiSnackbarContent-root {
    background-color: red;
  }
  .css-1exqwzz-MuiSnackbarContent-message {
    margin: 0 auto;
  }
`;

const SubmitBtn = styled.button`
  width: 20%;
  height: 100%;
  background-color: black;
  color: white;
  outline: none;
  border: none;
  white-space: nowrap;
`;

const MainInputText = styled.p`
  color: ${props => props.theme.style.middleGrey};
  margin-top: 2em;
  text-align: center;
  font-size: 1.5em;
`;

const MainTextBox = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")}
  border: 2px solid ${props => props.theme.style.black};
  margin: 3em 0;
`;

const MainTextCtn = styled.div`
  width: auto;
  padding: 3em 2em;
  font-size: 1.4em;
  line-height: 2em;
`;

const MainText = styled.div`
  strong {
    font-weight: 700;
  }
`;

const MainAlert = styled.div`
  font-family: ${props => props.theme.style.yangjin};
  background-color: ${props => props.theme.style.lightGrey};
  text-align: center;
  font-size: 1.5em;
  padding: 1em;
  border: 2px solid black;
`;

const MainStartBtnBox = styled.div`
  margin: 4em 0 2em;
  text-align: center;
`;

const MainStartBtn = styled.button`
  background-color: ${props => props.theme.style.red};
  color: ${props => props.theme.style.white};
  border: none;
  display: inline-block;
  width: 30%;
  min-width: 200px;
  height: 3em;
  margin: 0 auto;
  outline: none;
  border-radius: 8px;
  font-size: 2em;

  &:disabled {
    color: ${props => props.theme.style.red};
    border: 2px solid ${props => props.theme.style.red};
    background-color: transparent;
  }
`;
